import { bindActionCreators, Dispatch } from 'redux';
import { IRootState } from '../../redux/state';
import { IUser } from '../../models';
import { connect } from 'react-redux';
import SmartMap from './smartMap';
import genericMapActions from '../../redux/modules/genericMap/genericMapActions';
import { getRoutes } from '../../redux/modules/route/routeSelectors';
import { loadRoutes } from '../../redux/modules/route/routeCreators';

function mapStateToProps(state: IRootState) {
  const routes = getRoutes(state);
  return {
    authentication: state.authentication as unknown as IUser,
    isLoading: state.message.isLoading,
    routes: routes,
    selectedRouteIds: state.genericMapRoutes.routeIds,
    genericMapDrawnShapes: state.genericMapRoutes.genericMapDrawnShapes,
    mapCorners: state.genericMapRoutes.mapCorners,
    isAgreementsVisible: state.genericMapRoutes.isAgreementsVisible,
    zoomLevel: state.genericMapRoutes.zoomLevel,
    storedAgreements: state.genericMapRoutes.genericMapAgreements,
    filterType: state.genericMapRoutes.filterType,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    genericMapActions: bindActionCreators(genericMapActions, dispatch),
    loadRoutes: bindActionCreators(loadRoutes, dispatch),
  };
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(SmartMap);
